import { withUser } from 'components/queries/GetUserQuery';
import PaymentBookingPath from './PaymentBookingPath';

export default withUser(PaymentBookingPath);
